import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { applyOutlineTextToTitle, bodyLg, d2, d3, h1, responsiveStyle } from '@helpers/typography';
import { fluid } from '@netc/style-utils';
import styled, { css } from 'styled-components';
const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${fluid(12, 16)};
  flex-shrink: 0;
  max-width: 100%;

  > h2,
  > h1 {
    ${applyOutlineTextToTitle(`var(--widgetBg, ${brand.global.white})`, `var(--widgetFg, ${brand.ngbBlue.default})`)}
    ${(props) => responsiveStyle(d3, props['data-smaller-text'] ? h1 : d2, undefined, fonts.montserrat.extraBold, css `
          color: var(--widgetFg, ${brand.ngbBlue.default});
        `)};
    text-transform: uppercase;
  }

  > p {
    ${bodyLg}
    text-wrap: pretty;
    white-space: pre-wrap;
  }
`;
export const SectionIntroStyles = {
    Container,
};
